export default "__VITE_ASSET__CDjq8Zaq__"